<style scoped lang="less">
.done{
  display: flex;
  justify-content:center;
  align-items: center;
  flex-flow: column;
  height: calc(100vh - 64px - 137px - 16px);
  padding: 0;
  background: #fff;
  .icon{
    font-size: 70px;
    color: #99EA9B;
  }
  .text{
    font-size: 24px;
    font-weight: bold;
    margin-top: 40px;
  }
  .desc{
    font-size: 16px;
    color: rgba(0,0,0,.45);
    margin-top: 12px;
  }
  .back{
    margin-top: 48px;
    padding: 0px 40px;
  }
}
</style>
<template>
  <div class="done">
    <a-icon class='icon' type="check-circle" />
    <span class='text' slot="description">订单支付完成</span>
    <div class="desc">您已下单开发“{{info.project_name}}”的“{{info.version_name}}”</div>
    <a-button type="primary" class="back" @click="onBack"
      >返回</a-button
    >
  </div>
</template>
<script>
export default {
  data () {
    return {
      info: {}
    }
  },
  methods: {
    onBack () {
      this.$router.push({
        path: '/pay',
        query: this.$route.query
      })
    },
    fetchOrder () {
      this.$post('/wuwei/api/orders/payProcess', {
        order_id: this.$route.query.order_id
      }).then(data => {
        this.info = data.result
      })
    }
  },
  mounted () {
    this.fetchOrder()
  }
}
</script>
